import React from "react";
import cimg from "../../images/rsvp/image-3.jpg";
import RSVPFrom from "../RSVPFrom/RSVPFrom";

interface RsvpSectionS2Props {
  rClass?: string;
}

const RsvpSectionS2: React.FC<RsvpSectionS2Props> = ({ rClass }) => {
  return (
    <section className={`wpo-contact-section-s2 ${rClass || ""}`}>
      <div className="contact-title">
        <h2 className="text-bottom wow fadeInDown" data-wow-duration="1200ms">
          Welcome To Our Big Day
        </h2>
      </div>

      <div className="container">
        <div className="row">
          {/* Left side: form section */}
          <div className="col col-lg-6 col-md-12 col-12">
            <div
              className="contact-wrap wow fadeInLeftSlow"
              data-wow-duration="1200ms"
            >
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  <div className="wpo-contact-section-wrapper">
                    <div className="wpo-contact-form-area">
                      <div className="section-title">
                        <h2>Your presence will make our wedding day complete.</h2>
                      </div>
                      <RSVPFrom />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right side: image */}
          <div className="col col-lg-6 col-md-12 col-12">
            <div
              className="contect-right-image wow fadeInRightSlow"
              data-wow-duration="1200ms"
            >
              <img src={cimg} alt="Wedding celebration" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RsvpSectionS2;
